module.exports = __webpack_public_path__ + "static/media/gu.1a167daa.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gu.svg
// module id = 2106
// module chunks = 0